export default __webpack_public_path__ + "static/media/icon-vouchers.a7bd49de.svg";